import { render, staticRenderFns } from "./JsonForm.vue?vue&type=template&id=f4803918&"
import script from "./JsonForm.vue?vue&type=script&lang=js&"
export * from "./JsonForm.vue?vue&type=script&lang=js&"
import style0 from "./JsonForm.vue?vue&type=style&index=0&id=f4803918&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports